<template>

  <step-block
    class="step-block--lines"
    v-bind="$attrs"
    v-on="$listeners"
    :cover-image="photo"
  >
  <template slot="labels">
      <img
        class="label-lines"
        v-if="icon"
        :src="icon"
      >
    </template>
    
    <div
      class="step-block__content gothic"
      :style="contentStyle"
    >
      <h2 class="heading">{{ name }}</h2>
      <p class="description">
        {{ description }}
      </p>
    </div>
  </step-block>
</template>

<script>
  export default {
    name: 'StyleBlock',
    props: {
      id: [String, Number],
      name: String,
      photo: String,
      icon: String,
      description: String,
      color: String,
    },
    computed: {
      contentStyle() {
        const { color } = this;
        const style = {};

        if (color) {
          style.backgroundColor = color;
        }

        return style;
      },
    },
  };
</script>
